import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { POLSTAT_INIT_LOADING, POLSTAT_INIT_SUCCESS, POLSTAT_INIT_FAIL } from '@/store/types'
export const state = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {

}

const mutations = {
  [POLSTAT_INIT_LOADING](state, err) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [POLSTAT_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [POLSTAT_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async polStatManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.polStatManagement
    commit(POLSTAT_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(POLSTAT_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(POLSTAT_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
